import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Title, Button } from '@nerdwallet/currency';

import CompanyJobList from './company-job-list/company-job-list';
import DepartmentBlog from './department-blog/department-blog';
import { getSlug } from '~/client/lib/department-utils';

class DepartmentPage extends Component {
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0; // eslint-disable-line no-multi-assign
  }

  render() {
    const { department } = this.props;

    return (
      <React.Fragment>
        <CompanyJobList
          jobs={department.jobs}
          currentDept={getSlug(department)}
        />
        {department.id === '1703' && (
          <div>
            <Title
              size="small"
              className={classNames([
                classes('text-align-center'),
                classes('margin-horizontal-auto'),
                classes('margin-bottom-4'),
                classes('margin-bottom-5--wide'),
              ])}
            >
              See What&apos;s Keeping Us Busy
            </Title>
            <DepartmentBlog />
          </div>
        )}
        {department.id === '2212' && (
          <div
            className={classNames([
              classes('text-align-center'),
              classes('margin-horizontal-auto'),
              classes('margin-bottom-4'),
              classes('margin-bottom-5--wide'),
            ])}
          >
            <Button href="https://medium.com/nerdwallet-design">
              hear from the design nerds
            </Button>
          </div>
        )}
      </React.Fragment>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
DepartmentPage.displayName = 'Department Page';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
DepartmentPage.propTypes = {
  department: PropTypes.shape({
    id: PropTypes.string,
    slug: PropTypes.string,
    name: PropTypes.string,
    jobs: PropTypes.arrayOf(PropTypes.shape(CompanyJobList.propTypes)),
  }),
};

export default DepartmentPage;
